import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import OpacityTransition from "@/components/transitions/OpacityTransition.vue";
import {computed, onBeforeUnmount, onMounted, onUnmounted, ref} from "vue";
import {bus} from "@/utils/event-bus";
import {AlertMessageInterface} from "@/utils/AlertMessageInterface";
import {useConfigStore} from "@/utils/store/useConfigStore";
import {UserConfig} from "@/config/UserConfig";
import {useLocalization} from "@/utils/useLocalization";
import FooterComponent from "@/components/FooterComponent.vue";
// import {useRoute} from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const alert = ref(null)

const configStore = useConfigStore()
const {t} = useLocalization()

// onMounted(() => {
//   const route = useRoute()
//   const queryParams = computed(() => route.query)
//   console.log(queryParams.value.utm_source)
// })

onBeforeUnmount(() => {
  const config = configStore.config.value === null ?
      new UserConfig().map({locale: 'en', theme: 'light'}) :
      configStore.config.value

  configStore.setConfig(config)
})

const onAlert = (payload: AlertMessageInterface) => {
  alert.value.showAlert(
      payload.type,
      payload.message,
      payload.header,
      {
        iconSize: payload.iconSize,
        iconType: payload.iconStyle
      }
  )
}
bus.on('alert', (payload: AlertMessageInterface) => onAlert(payload))

onUnmounted(() => {
  bus.off('alert')
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_vue_basic_alert = _resolveComponent("vue-basic-alert")!
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", null, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('Главная')), 1)
        ]),
        _: 1
      }),
      _createTextVNode(" | "),
      _createVNode(_component_router_link, { to: "/about" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('О команде')), 1)
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_vue_basic_alert, {
      duration: 300,
      closeIn: 3000,
      ref_key: "alert",
      ref: alert
    }, null, 512),
    _createVNode(_component_RouterView, null, {
      default: _withCtx(({ Component }) => [
        _createVNode(OpacityTransition, null, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }),
    _createVNode(FooterComponent)
  ], 64))
}
}

})